import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import Content from '../../content-manager/content';
import tinyMCEConfig from '../../utilities/tinymce_config';
import {updateScore, removeQuestion, ITEM_TYPE_GLOBAL, ITEM_TYPE_STYLE} from './actions';
import { ServerDate } from '../../containers/ServerDate';

//@Radium
export default class Item extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.onContentChange = this.onContentChange.bind(this);
    }

    componentDidMount() {
        const clearEdit = async ({target}) => {
            if (this.resizing)
                return;
            await window.wait();
            if (
                this.props.edit &&
                this.props.page === this.props.currentPage &&
                !this.refs.item?.contains(target) &&
                (
                    !target.closest ||
                    !target.closest('.mce-floatpanel')
                )
            ) {
                this.props.setEdit(null);
                window.tinyMCE.get('editor-' + this.props.item.get('id')).setMode('readonly');
            }
        };
        window.addEventListener('mouseup', clearEdit, true);
        this.cleanUp = () => window.removeEventListener('mouseup', clearEdit, true);
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    onContentChange() {
        const height = window.tinyMCE.get('editor-' + this.props.item.get('id')).getBody().clientHeight +
            this.props.store.get('padding') * 2 * this.props.verticalCentimeter - .01;
        if (height > this.refs.item.clientHeight)
            this.refs.item.style.backgroundColor = styles.alertBackColor;
        else
            this.refs.item.style.backgroundColor = this.props.active ? '#eaeaea' : undefined;
    }

    render() {
        return <div
            ref='itemContainer'
            style={{
                position: 'absolute',
                top: this.props.item.get('top') + this.props.store.get('marginTop') + 'cm',
                right: this.props.item.get('right') + this.props.store.get('marginRight') + 'cm',
                zIndex: ((this.props.active ? 2 : 0) + (this.props.item.get('question_id') ? 2 : 1)).toString(),
                pointerEvents: this.props.item.get('page') === ITEM_TYPE_STYLE ? 'none' : undefined,
            }}>
            {this.props.renderMaterial
                ? <div
                    style={{
                        fontSize: '12pt',
                        backgroundColor: '#eaeaea',
                        display: 'inline-block',
                        paddingTop: '.2em',
                        paddingBottom: '.2em',
                        paddingLeft: '.7em',
                        paddingRight: '.7em',
                    }}>
                    ∴  {this.props.item.get('material')}
                </div>
                : null
            }
            <div
                ref='item'
                style={{
                    position: 'relative',
                    width: this.props.item.get('width') + 'cm',
                    height: this.props.item.get('height') + 'cm',
                    border: this.props.item.get('page') === ITEM_TYPE_STYLE ? undefined : this.props.type === 1
                        ? this.props.item.get('overlap') ? `.0125em dotted ${styles.alertColor}` :  '.0125em dotted #cacaca'
                        : this.props.item.get('overlap') ? `.5mm solid ${styles.alertColor}` :  '.5mm solid black',
                    boxSizing: 'border-box',
                    userSelect: 'none',
                    backgroundColor: this.props.active ? '#eaeaea' : undefined,
                }}
                draggable={this.props.mode !== 'scores' && !this.props.edit}
                onDragStart={event => {
                    if (
                        this.props.locked ||
                        this.props.mode === 'scores' ||
                        this.props.edit ||
                        !this.props.active
                    ) {
                        event.preventDefault();
                        return;
                    }
                    if (!event.altKey) {
                        event.preventDefault();
                        return;
                    }
                    event.dataTransfer.setData('question-id', this.props.item.get('id'));
                    event.dataTransfer.setData('offsetX', event.nativeEvent.offsetX);
                    event.dataTransfer.setData('offsetY', event.nativeEvent.offsetY);
                }}
                onMouseUp={event => {
                    if (
                        this.props.locked ||
                        this.props.mode === 'scores' ||
                        this.refs.refresh &&
                        this.refs.refresh.contains(event.target) ||
                        this.refs.reorder &&
                        this.refs.reorder.contains(event.target) ||
                        this.refs.editButton &&
                        this.refs.editButton.contains(event.target) ||
                        this.refs.removeButton &&
                        this.refs.removeButton.contains(event.target) ||
                        this.refs.template &&
                        this.refs.template.contains(event.target)
                    )
                        return;
                    this.props.setActive(this.props.item.get('id'));
                }}
                onMouseDown={event => {
                    if (
                        this.props.locked ||
                        this.props.mode === 'scores' ||
                        this.props.edit ||
                        !this.props.active ||
                        event.altKey
                    )
                        return;
                    this.refs.item.setAttribute('draggable', false);

                    if (
                        event.target === this.refs.refresh ||
                        event.target === this.refs.reorder ||
                        event.target === this.refs.editButton ||
                        event.target === this.refs.removeButton ||
                        event.target === this.refs.templates
                    )
                        return;

                    const node = this.refs.item;
                    const container = this.refs.itemContainer;
                    const rect = container.getBoundingClientRect();
                    const offsetX = event.clientX - rect.left;
                    const offsetY = event.clientY - rect.top;
                    const timestamp = ServerDate().getTime();
                    const mouseMoveHandler = event => {
                        let width = Number.parseFloat(node.style.width);
                        let height = Number.parseFloat(node.style.height);
                        const rect = this.props.container.getBoundingClientRect();
                        let top = (event.clientY - rect.top - offsetY) / this.props.verticalCentimeter;
                        let right = this.props.store.get('width') - (event.clientX - rect.left - offsetX) /
                            this.props.horizontalCentimeter - width;
                        top = Math.min(
                            Math.max(top, this.props.store.get('marginTop')),
                            this.props.store.get('height') - this.props.store.get('marginBottom') - height,
                        );
                        right = Math.min(
                            Math.max(right, this.props.store.get('marginRight')),
                            this.props.store.get('width') - this.props.store.get('marginLeft') - width,
                        );
                        container.style.top = top + 'cm';
                        container.style.right = right + 'cm';
                    };
                    const mouseUpHandler = event => {
                        this.refs.item.setAttribute('draggable', this.props.mode !== 'scores' && !this.props.edit);
                        document.removeEventListener('mousemove', mouseMoveHandler, true);
                        document.removeEventListener('mouseup', mouseUpHandler, true);
                        if (
                            ServerDate().getTime() - timestamp < 1500 &&
                            Math.abs((event.clientX - rect.left) - offsetX) +
                            Math.abs((event.clientY - rect.top) - offsetY) < 1
                        )
                            return;
                        event.stopPropagation();
                        this.context.store.dispatch(this.props.updater(
                            this.props.item.merge({
                                top: Number.parseFloat(container.style.top) - this.props.store.get('marginTop'),
                                right: Number.parseFloat(container.style.right) - this.props.store.get('marginRight'),
                            }),
                            this.props.elementId,
                        ));
                    };
                    document.addEventListener('mousemove', mouseMoveHandler, true);
                    document.addEventListener('mouseup', mouseUpHandler, true);
                }}>
                {Number.isInteger(this.props.item.get('index'))
                    ? <div
                        className={_.includes(this.props.item.get('content'), 'english-ltr') ? 'question english-ltr' : 'question persian'}
                        style={{
                            position: 'absolute',
                            top: this.props.store.get('padding') + 'cm',
                            [_.includes(this.props.item.get('content'), 'english-ltr') ? 'right' : 'left']: '100%',
                            direction: [_.includes(this.props.item.get('content'), 'english-ltr') ? 'ltr' : 'rtl'],
                            [_.includes(this.props.item.get('content'), 'english-ltr') ? 'marginRight' : 'marginLeft']: '1mm',
                            fontWeight: '700',
                        }}>
                        {_.includes(this.props.item.get('content'), 'english-ltr')
                            ? (this.props.item.get('index') + 1)
                            : (this.props.item.get('index') + 1).persian()
                        }.
                    </div>
                    : null
                }
                {this.props.active
                    ? <div
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            top: '0',
                            left: '0',
                            zIndex: '4',
                        }}>
                        {this.props.mode === 'scores'
                            ? <i
                                ref={'reset-scores-' + this.props.item.get('id')}
                                key={'reset-scores-' + this.props.item.get('id')}
                                style={{
                                    margin: '.2em',
                                    opacity: '.5',
                                    cursor: 'pointer',
                                    backgroundColor: 'rgba(255, 255, 255, .6)',
                                    ':hover': {
                                        backgroundColor: 'rgba(255, 255, 255, .8)',
                                        opacity: '1',
                                    },
                                }}
                                onClick={() => this.context.store.dispatch(this.props.updater(
                                    this.props.item.set('scores', null),
                                    this.props.elementId,
                                ))}
                                className='fa-pencil-square-o'>
                            </i>
                            : [
                                <i
                                    ref='refresh'
                                    key='refresh'
                                    style={{
                                        margin: '.2em',
                                        opacity: '.5',
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(255, 255, 255, .6)',
                                        ':hover': {
                                            backgroundColor: 'rgba(255, 255, 255, .8)',
                                            opacity: '1',
                                        },
                                    }}
                                    onClick={() => this.context.store.dispatch(this.props.updater(
                                        this.props.item.merge({
                                            top: null,
                                            right: null,
                                            width: null,
                                            height: null,
                                        }),
                                        this.props.elementId,
                                    ))}
                                    className='fa-arrows'>
                                </i>,
                                <i
                                    ref='reorder'
                                    key='reorder'
                                    style={{
                                        margin: '.2em',
                                        opacity: '.5',
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(255, 255, 255, .6)',
                                        ':hover': {
                                            backgroundColor: 'rgba(255, 255, 255, .8)',
                                            opacity: '1',
                                        },
                                    }}
                                    onClick={() => this.context.store.dispatch(this.props.updater(
                                        this.props.item.set('top', null),
                                        this.props.elementId,
                                    ))}
                                    className='fa-arrows-v'>
                                </i>,
                                ...(this.props.item.get('question_id')
                                    ? [
                                        <i
                                            ref='edit-button'
                                            key='edit-button'
                                            style={{
                                                margin: '.2em',
                                                opacity: '.5',
                                                cursor: 'pointer',
                                                backgroundColor: 'rgba(255, 255, 255, .6)',
                                                ':hover': {
                                                    backgroundColor: 'rgba(255, 255, 255, .8)',
                                                    opacity: '1',
                                                },
                                            }}
                                            onClick={() => this.context.store.dispatch(
                                                push(this.context.store.getState().getIn(
                                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                                ) + `${this.props.item.get('question_id')}/`),
                                            )}
                                            className='fa-pencil'>
                                        </i>,
                                    ]
                                    : [
                                        <i
                                            ref='remove-button'
                                            key='remove-button'
                                            style={{
                                                margin: '.2em',
                                                opacity: '.5',
                                                cursor: 'pointer',
                                                backgroundColor: 'rgba(255, 255, 255, .6)',
                                                ':hover': {
                                                    backgroundColor: 'rgba(255, 255, 255, .8)',
                                                    opacity: '1',
                                                },
                                            }}
                                            onClick={() => {
                                                if (!window.confirm(window.gettext(
                                                    'Are you sure you wanna remove this element?',
                                                )))
                                                    return;
                                                this.context.store.dispatch(removeQuestion(
                                                    this.props.item.get('id'),
                                                    this.props.elementId,
                                                ));
                                            }}
                                            className='fa-trash'>
                                        </i>,
                                        <i
                                            ref='template'
                                            key='template'
                                            style={{
                                                margin: '.2em',
                                                opacity: '.5',
                                                cursor: 'pointer',
                                                backgroundColor: 'rgba(255, 255, 255, .6)',
                                                ':hover': {
                                                    backgroundColor: 'rgba(255, 255, 255, .8)',
                                                    opacity: '1',
                                                },
                                            }}
                                            onClick={() => this.context.store.dispatch(this.props.updater(
                                                this.props.item.set(
                                                    'page',
                                                    this.props.item.get('page') === ITEM_TYPE_GLOBAL ? this.props.currentPage : ITEM_TYPE_GLOBAL,
                                                ),
                                                this.props.elementId,
                                            ))}
                                            className={this.props.item.get('page') === ITEM_TYPE_GLOBAL ? 'fa-insert-template' : 'fa-object-ungroup'}>
                                        </i>,
                                    ]
                                ),
                            ]
                        }
                    </div>
                    : null
                }
                {_.map(
                    this.props.mode === 'scores' || !this.props.active ? [] : Array(8),
                    (__, index) => {
                        const i = Math.floor(index / 3);
                        const j = index % 3;
                        return <div
                            key={index}
                            style={{
                                position: 'absolute',
                                top: {
                                    0: '-.25em',
                                    1: 'calc(100% - .25em)',
                                    2: 'calc(50% - .25em)',
                                }[i],
                                right: {
                                    0: '-.25em',
                                    1: 'calc(100% - .25em)',
                                    2: 'calc(50% - .25em)',
                                }[j],
                                cursor: {
                                    0: 'nesw',
                                    1: 'nwse',
                                    2: 'ns',
                                    3: 'nwse',
                                    4: 'nesw',
                                    5: 'ns',
                                    6: 'ew',
                                    7: 'ew',
                                }[index] + '-resize',
                                width: '.5em',
                                height: '.5em',
                                border: '.0625em solid black',
                                boxSizing: 'border-box',
                                zIndex: '3',
                            }}
                            onMouseDown={event => {
                                if (event.altKey)
                                    return;
                                if (this.props.edit)
                                    return;
                                event.stopPropagation();
                                const node = this.refs.item;
                                const container = this.refs.itemContainer;
                                this.refs.item.setAttribute('draggable', false);
                                const offsetTop = node.getBoundingClientRect().top - container.getBoundingClientRect().top;
                                this.resizing = true;
                                const mouseMoveHandler = event => {
                                    let top = Number.parseFloat(container.style.top);
                                    let right = Number.parseFloat(container.style.right);
                                    let width = Number.parseFloat(node.style.width);
                                    let height = Number.parseFloat(node.style.height);
                                    const rect = this.props.container.getBoundingClientRect();
                                    if (i === 0 && top + height - (event.clientY - rect.top - offsetTop) / this.props.verticalCentimeter > 0) {
                                        height = top + height - (event.clientY - rect.top - offsetTop) / this.props.verticalCentimeter;
                                        top = (event.clientY - rect.top - offsetTop) / this.props.verticalCentimeter;
                                    }
                                    if (i === 1 && -top + (event.clientY - rect.top - offsetTop) / this.props.verticalCentimeter > 0) {
                                        height = -top + (event.clientY - rect.top - offsetTop) / this.props.verticalCentimeter;
                                    }
                                    if (j === 0 && right + width - (this.props.store.get('width') -
                                        (event.clientX - rect.left) / this.props.horizontalCentimeter) > 0) {
                                        width = right + width - (this.props.store.get('width') -
                                            (event.clientX - rect.left) / this.props.horizontalCentimeter);
                                        right = this.props.store.get('width') - (event.clientX - rect.left) /
                                            this.props.horizontalCentimeter;
                                    }
                                    if (j === 1 && -right + this.props.store.get('width') -
                                        (event.clientX - rect.left) / this.props.horizontalCentimeter > 0) {
                                        width = -right + this.props.store.get('width') -
                                            (event.clientX - rect.left) / this.props.horizontalCentimeter;
                                    }
                                    width = Math.min(
                                        width,
                                        this.props.store.get('width') - this.props.store.get('marginLeft') - right,
                                    );
                                    height = Math.min(
                                        height,
                                        this.props.store.get('height') - this.props.store.get('marginBottom') - top,
                                    );
                                    if (top < this.props.store.get('marginTop')) {
                                        height -= this.props.store.get('marginTop') - top;
                                        top = this.props.store.get('marginTop');
                                    }
                                    if (right < this.props.store.get('marginRight')) {
                                        width -= this.props.store.get('marginRight') - right;
                                        right = this.props.store.get('marginRight');
                                    }
                                    _.forEach(
                                        ['top', 'right'],
                                        property => container.style[property] = eval(property) + 'cm',
                                    );
                                    _.forEach(
                                        ['width', 'height'],
                                        property => node.style[property] = eval(property) + 'cm',
                                    );
                                };
                                const mouseUpHandler = event => {
                                    event.stopPropagation();
                                    this.refs.item.setAttribute('draggable', this.props.mode !== 'scores' && !this.props.edit);
                                    document.removeEventListener(
                                        'mousemove',
                                        mouseMoveHandler,
                                        true,
                                    );
                                    document.removeEventListener('mouseup', mouseUpHandler, true);
                                    this.context.store.dispatch(this.props.updater(
                                        this.props.item.merge({
                                            top: Number.parseFloat(node.style.top) - this.props.store.get('marginTop'),
                                            right: Number.parseFloat(node.style.right) - this.props.store.get('marginRight'),
                                            width: Number.parseFloat(node.style.width),
                                            height: Number.parseFloat(node.style.height),
                                        }),
                                        this.props.elementId,
                                    ));
                                    this.resizing = false;
                                };
                                document.addEventListener('mousemove', mouseMoveHandler, true);
                                document.addEventListener('mouseup', mouseUpHandler, true);
                            }}>
                        </div>;
                    },
                )}
                {this.props.active
                    ? <div
                        ref={'fake-item-' + this.props.item.get('id')}
                        style={{
                            position: 'absolute',
                            zIndex: '1',
                            top: '0',
                            right: '0',
                            width: '100%',
                            height: '100%',
                            pointerEvents: this.props.mode === 'scores'
                                ? 'auto'
                                : this.props.edit ? 'none' : 'auto',
                        }}
                        onMouseUp={() => {
                            this.props.setEdit(this.props.item.get('id'));
                            window.tinyMCE.get('editor-' + this.props.item.get('id')).setMode('design');
                            window.tinyMCE.get('editor-' + this.props.item.get('id')).focus();
                        }}>
                    </div>
                    : null
                }
                <div style={{position: 'absolute', width: '100%', height: '100%'}}>
                    {this.props.mode === 'scores' && this.props.item.get('scores')
                        ? this.props.item.get('scores').map((score, index) => <div
                            key={index}
                            style={{
                                position: 'absolute',
                                display: 'flex',
                                zIndex: '2',
                                top: `calc(${score.get('top')}px - 1.125em)`,
                                right: `calc(${score.get('right')}px - 1.125em)`,
                                cursor: '-webkit-grab',
                                color: 'rgba(255, 0, 0, .7)',
                                fontFamily: 'Dast Nevis',
                                fontSize: '1.5rem',
                                border: '.125em solid rgba(255, 0, 0, .5)',
                                borderRadius: '50%',
                                width: '2em',
                                height: '2em',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: '1',
                            }}
                            onMouseDown={event => {
                                if (this.props.edit)
                                    return;
                                const node = event.currentTarget;
                                const relatedNodes = node.parentElement.parentElement.querySelectorAll(
                                    `.score[data-score-id="${score.get('id')}"]`,
                                );
                                const backgrounds = [];
                                _.forEach(relatedNodes, node => {
                                    backgrounds.push(node.style.backgroundColor);
                                    node.style.backgroundColor = 'rgb(255, 100, 100)';
                                });
                                node.style.cursor = '-webkit-grabbing';
                                const rect = node.getBoundingClientRect();
                                const containerRect = node.parentElement.getBoundingClientRect();
                                const width = rect.width;
                                let offsetX = event.clientX - rect.left;
                                let offsetY = event.clientY - rect.top;
                                const mouseDownHandler = event => event.stopPropagation();
                                const mouseMoveHandler = event => {
                                    let top = (event.clientY - containerRect.top - offsetY);
                                    let right = (
                                        containerRect.width -
                                        (event.clientX - containerRect.left - offsetX) - width
                                    );
                                    top = Math.max(0, Math.min(
                                        containerRect.height - rect.height,
                                        top,
                                    ));
                                    right = Math.max(0, Math.min(
                                        containerRect.width - rect.width,
                                        right,
                                    ));
                                    node.style.top = top + 'px';
                                    node.style.right = right + 'px';
                                };
                                const mouseUpHandler = event => {
                                    if (
                                        Math.abs(node.getBoundingClientRect().top - rect.top) +
                                        Math.abs(node.getBoundingClientRect().right - rect.right) < 10
                                    ) {
                                        offsetX = rect.width / 2;
                                        offsetY = rect.height / 2;
                                        document.addEventListener('mousedown', mouseDownHandler, true);
                                        return;
                                    }
                                    node.style.cursor = '-webkit-grab';
                                    _.forEach(
                                        relatedNodes,
                                        (node, index) => node.style.backgroundColor = backgrounds[index],
                                    );
                                    let top = (event.clientY - containerRect.top - offsetY);
                                    let right = (
                                        containerRect.width -
                                        (event.clientX - containerRect.left - offsetX) - width
                                    );
                                    top = Math.max(0, Math.min(
                                        containerRect.height - rect.height,
                                        top,
                                    ));
                                    right = Math.max(0, Math.min(
                                        containerRect.width - rect.width,
                                        right,
                                    ));
                                    node.style.top = top + 'px';
                                    node.style.right = right + 'px';
                                    const nodeRect = node.getBoundingClientRect();
                                    this.context.store.dispatch(updateScore(
                                        this.props.item.get('id'),
                                        score.get('id'),
                                        {
                                            top: (
                                                nodeRect.top - containerRect.top +
                                                nodeRect.bottom - containerRect.top
                                            ) / 2,
                                            right: containerRect.width - (
                                                nodeRect.left - containerRect.left +
                                                nodeRect.right - containerRect.left
                                            ) / 2,
                                        },
                                        this.props.elementId,
                                    ));
                                    document.removeEventListener('mousedown', mouseDownHandler, true);
                                    document.removeEventListener('mousemove', mouseMoveHandler, true);
                                    document.removeEventListener('mouseup', mouseUpHandler, true);
                                };
                                document.addEventListener('mousemove', mouseMoveHandler, true);
                                document.addEventListener('mouseup', mouseUpHandler, true);
                            }}>
                            {score.get('score')}
                        </div>).toArray()
                        : null
                    }
                </div>
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        overflow: this.props.edit ? undefined : 'hidden',
                        padding: this.props.item.get('page') === ITEM_TYPE_STYLE ? undefined : this.props.store.get('padding') + 'cm',
                        boxSizing: 'border-box',
                    }}>
                    {this.props.active && (this.props.item.get('page') !== ITEM_TYPE_GLOBAL || this.props.page === this.props.currentPage)
                        ? <Content
                            key={'content-' + this.props.item.get('id')}
                            style={{width: '100%'}}
                            id={'editor-' + this.props.item.get('id')}
                            uploadImages={!Number.isInteger(this.props.item.get('index'))}
                            embedImages
                            inline
                            content={this.props.item.get('content')}
                            tinymceConfig={{
                                ...tinyMCEConfig,
                                toolbar: [
                                    ...tinyMCEConfig.toolbar.slice(0, -1),
                                    tinyMCEConfig.toolbar.slice(-1)[0] + ' question',
                                ],
                            }}
                            onInit={() => {
                                const height = window.tinyMCE.get('editor-' + this.props.item.get('id')).getBody().clientHeight +
                                    this.props.store.get('padding') * 2 * this.props.verticalCentimeter - .01;
                                if (height > this.refs.item.clientHeight)
                                    this.refs.item.style.backgroundColor = styles.alertBackColor;
                                else
                                    this.refs.item.style.backgroundColor = this.props.active ? '#eaeaea' : undefined;
                                if (!this.props.edit)
                                    window.tinyMCE.get('editor-' + this.props.item.get('id')).setMode('readonly');
                                window.tinyMCE.get('editor-' + this.props.item.get('id')).getBody().style.display = 'inline-block';

                            }}
                            onFocusin={() => this.props.setEdit(this.props.item.get('id'))}
                            onFocusout={content => {
                                this.context.store.dispatch(this.props.updater(
                                    this.props.item.set('content', content),
                                    this.props.elementId,
                                ));
                            }}
                            onChange={this.onContentChange}
                        />
                        : <div
                            key={'content-' + this.props.item.get('id')}
                            style={{
                                width: '100%',
                                height: '100%',
                                ...styles.content,
                            }}
                            dangerouslySetInnerHTML={{__html: this.props.contentProcessor(this.props.item.get('content'))}}
                        />
                    }
                </div>
            </div>
        </div>;
    }
}
